import { LabeledBar } from "../../../../ui/dataInfo/LabeledBar";
import { ComponentF, createElement } from "../../../../ui/ui";
import { Encumbrance } from "../../../actors/Actor";
import Colors from "../../../Colors";
import { gameData } from "../../../GameManager";
import {
  getActorWeight,
  getWeightLevel,
  getWeightLoad,
} from "../../../items/formulas";
import { XPBar } from "./XPBar";

export const StatsPanel: ComponentF<void> = (C, props) => {
  C.display.drawText(
    C.bounds.x,
    C.bounds.y + 3,
    `FRC: ${gameData.player.attributes.force}`
  );

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + 4,
    `STR: ${gameData.player.attributes.strength}`
  );

  const weight = getActorWeight(gameData.player);
  const maxWeight = gameData.player.attributes.weight;
  C.display.drawText(
    C.bounds.x,
    C.bounds.y + 7,
    `WEIGHT: ${weight}/${maxWeight} (${getWeightLoad(weight, maxWeight)}%)`
  );
  const eLevel = getWeightLevel(weight, maxWeight);

  C.display.drawText(
    C.bounds.x,
    C.bounds.y + 8,
    eLevel === Encumbrance.HEAVY
      ? "Slow movement"
      : eLevel === Encumbrance.MEDIUM
      ? "Medium Movement"
      : "Fast Movement"
  );
  C.display.drawText(
    C.bounds.x,
    C.bounds.y + 9,
    eLevel === Encumbrance.HEAVY
      ? `%c{${Colors.RED_2}}No Sprinting`
      : eLevel === Encumbrance.MEDIUM
      ? "Shift Move Sprint"
      : "Shift Move Sprint Atk"
  );
  return [
    createElement(XPBar, { x: 0, y: 0, w: C.bounds.w - 11, h: 3 }),
    createElement(
      LabeledBar,
      { x: C.bounds.w - 10, y: 0, w: 10, h: 1 },
      {
        title: "Health",
        fillColor: "#702931",
        current: gameData.player.health.current,
        max: gameData.player.health.max,
      }
    ),
    createElement(
      LabeledBar,
      { x: C.bounds.w - 10, y: 2, w: 10, h: 1 },
      {
        title: "Stamina",
        fillColor: "#2b4147",
        current: gameData.player.stamina.current,
        max: gameData.player.stamina.max,
      }
    ),
    createElement(
      LabeledBar,
      { x: C.bounds.w - 10, y: 4, w: 10, h: 1 },
      {
        title: "Poise",
        fillColor: "#45538f",
        current: gameData.player.poise.current,
        max: gameData.player.poise.max,
      }
    ),
  ];
};
